"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WNL = void 0;
exports.WNL = {
    id: 'wnl',
    companyName: 'WNL',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'wnl',
    },
    isInternal: false,
    isActive: false,
    countries: [],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV05MLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL1dOTC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLEdBQUcsR0FBVTtJQUN0QixFQUFFLEVBQUUsS0FBSztJQUNULFdBQVcsRUFBRSxLQUFLO0lBQ2xCLGNBQWMsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUN2QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUsS0FBSztLQUNmO0lBQ0QsVUFBVSxFQUFFLEtBQUs7SUFDakIsUUFBUSxFQUFFLEtBQUs7SUFDZixTQUFTLEVBQUUsRUFBRTtDQUNoQixDQUFBIn0=